import { queryParamsWhitelist as defaultQueryParamsWhitelist } from '../queryParamsWhitelist'
import { NavigationManagerSymbol, INavigationManager } from 'feature-navigation-manager'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { IQueryParamsWhitelistHandler } from '../types'

const queryParamsWhitelistFactory = (navigationManager: INavigationManager): IQueryParamsWhitelistHandler => {
	let queryParamsWhitelist: Set<string>
	return {
		getWhitelist: (url: URL) => {
			if (navigationManager.isFirstNavigation()) {
				// @ts-ignore - ts thinks there's no entries() on searchParams, but it's there.
				const entries = url.searchParams.entries()
				const queryParamsFromUrl = [...entries].map(([queryParam]) => queryParam)
				queryParamsWhitelist = new Set(...[queryParamsFromUrl.concat([...defaultQueryParamsWhitelist])])
			}

			return queryParamsWhitelist
		},
	}
}

export const queryParamsWhitelistHandler = withDependencies([NavigationManagerSymbol], queryParamsWhitelistFactory)
